module.exports = __webpack_public_path__ + "img/Screenshot_4.cefed49b.png";